import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ApplicationClientCommonModule, CommonTranslationModule } from '@sdbn/common';
import { StackedBarchartModule } from '../stacked-bar-chart/stackedbarchart.module';
import { StatusComponent } from './status.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    StackedBarchartModule,
    CommonTranslationModule,
    ApplicationClientCommonModule
  ],
  declarations: [
    StatusComponent
  ]
})
export class StatusModule { }
